<template>
  <filter-bar
    label="Contact Not Made Pipeline"
    :filter-text="filterText"
    :reset="resetFilters"
  >
    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="contactingState"
        filter-name="contacting"
        @change="usersFilterText = $event"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-statuses
        store-module="contactingState"
        filter-name="contacting"
        @change="statusesFilterText = $event"
        statuses-name="contactingStatusesInView"
      ></filter-statuses>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="contactingState"
        filter-name="contacting"
        @change="campaignsFilterText = $event"
      ></filter-campaigns>
    </filter-item>

    <filter-item>
      <filter-temperatures
        store-module="contactingState"
        filter-name="contacting"
        @change="temperaturesFilterText = $event"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="contactingState"
        filter-name="contacting"
        @change="dealProbabilityScoreText = $event"
      ></filter-deal-probability-score>
    </filter-item>

    <filter-item>
      <filter-sources
        store-module="contactingState"
        filter-name="contacting"
        @change="sourcesFilterText = $event"
      ></filter-sources>
    </filter-item>
  </filter-bar>
</template>

<script>
export default {
  name: "ContactingFilters",
  data() {
    return {
      validationErrors: {},
      usersFilterText: null,
      campaignsFilterText: null,
      temperaturesFilterText: null,
      dealProbabilityScoreText: null,
      sourcesFilterText: null,
      statusesFilterText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.temperaturesFilterText) array.push(this.temperaturesFilterText);
      if (this.dealProbabilityScoreText) array.push(this.dealProbabilityScoreText);
      if (this.sourcesFilterText) array.push(this.sourcesFilterText);
      if (this.statusesFilterText) array.push(this.statusesFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    resetFilters() {
      this.usersFilterText = null;
      this.campaignsFilterText = null;
      this.temperaturesFilterText = null;
      this.dealProbabilityScoreText = null;
      this.sourcesFilterText = null;
      this.statusesFilterText = null;

      this.$store.commit("contactingState/resetFilters", "contacting");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.filter_bar {
  padding-right: $defaultGap + 16px !important;
}
</style>
